import styled from "styled-components";

export const TableAction = styled.div`
  margin-bottom: 24px;
  .first-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .actions {
    width: 100%;
    text-align: right;
    .addBtn {
      background: linear-gradient(to right, #0486f6, #53c6fd);
      border-radius: 16px !important;
      font-size: 16px;
      width: 149px;
      height: 56px;
    }
    .btnCourseBox {
      width: 230px;
      border-radius: 16px;
      background: #f5f5f5;
      display: flex;
      margin-left: 16px;
    }
    .addBtnCourse {
      width: 149px;
      height: 56px;
      background: #f5f5f5;
      color: #bdbdbd;
      font-weight: 600;
    }
    .addBtnCourse.active {
      background: #ffffff;
      color: blue;
      border: 2px solid rgba(0, 0, 0, 0.1);
    }
  }
  .search-row {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 16px;
    padding: 0 16px;
    gap: 5px;
    & > span {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      svg path {
        fill: #bdbdbd;
      }
    }
    input {
      width: 500px;
      outline: none;
      border: none;
      padding: 18px 0;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      background: #f5f5f5;
      border-radius: 16px;
      &::placeholder {
        color: #bdbdbd;
      }
    }
  }
`;
